import React from 'react';
import ReactDOM from 'react-dom';
// eslint-disable-next-line import/extensions
import Button from './button.jsx';

const rootElement = document.getElementById('contact-button-container');

if (rootElement) {
    const { url, isAdOwner, adId, loginId, disabled } = rootElement.dataset;
    ReactDOM.hydrate(
        <Button
            url={url}
            isAdOwner={isAdOwner === 'true'}
            adId={adId}
            loginId={loginId}
            disabled={disabled}
        />,
        rootElement,
    );
}
